import ApiCall from "./ApiCall";

// Read ?redirect_to from the current URL.
export function getRedirectTo() {
    try {
        return new URLSearchParams(window.location.search).get("redirect_to");
    } catch (e) {
        return null;
    }
}

// Mint a one-time support token for the authenticated supplier and bounce the
// browser to the support portal. Returns true if the redirect was triggered.
export async function handoffToSupport(token) {
    try {
        const res = await ApiCall("post", "support-login-token", {}, token);
        const supportToken = res?.data?.token;
        if (supportToken) {
            const base = (process.env.REACT_APP_SUPPORT_URL || "http://localhost:8002").replace(/\/$/, "");
            window.location.href = base + "/impersonate/" + supportToken;
            return true;
        }
    } catch (e) {
        /* fall through to the normal redirect */
    }
    return false;
}

// Same hand-off, but into a window opened by the caller (a new tab).
// The caller must open the window synchronously on the click (so the popup
// blocker allows it); we then point it at the impersonate URL once the
// one-time token is minted.
export async function handoffToSupportNewTab(token, win) {
    try {
        const res = await ApiCall("post", "support-login-token", {}, token);
        const supportToken = res?.data?.token;
        if (supportToken && win) {
            const base = (process.env.REACT_APP_SUPPORT_URL || "http://localhost:8002").replace(/\/$/, "");
            win.location.href = base + "/impersonate/" + supportToken;
            return true;
        }
    } catch (e) {
        /* fall through */
    }
    if (win) {
        try { win.close(); } catch (e) { /* ignore */ }
    }
    return false;
}
